<script lang="ts">
	import { browser } from "$app/environment";
	import { createScrollContext, ScrollTracker } from "$lib/ui/scroll/index.svelte";
	import { onDestroy, onMount, setContext } from "svelte";

	
	const scroll = createScrollContext()

	onMount(() => {
		scroll.init();
	});

	onDestroy(() => {
		if (!browser) return;
		scroll.destroy();
	});
</script>
<slot />
